import React from "react";
//#region types
import { MultiPersonNamesProps } from "models/propTypes/userProfilePropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { SimpleTooltip } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const MultiPersonNames: React.FC<MultiPersonNamesProps> = ({ profiles, maxProfiles }) => {
  const maxToShow = maxProfiles ?? profiles.length;
  const profilesToShow = profiles.slice(0, maxToShow);
  const hiddenProfiles = profiles.slice(maxToShow);
  const hiddenProfileNames = hiddenProfiles.map((p) => p.name).join(", ");

  return (
    <Grid container direction="row" wrap="nowrap" alignItems="flex-start">
      {profilesToShow.map((p, index) => (
        <React.Fragment key={p.id}>
          <Grid item className={clsx(cssExports.personName, cssExports.truncateString)}>
            <span>{p.name}</span>
          </Grid>
          {(index < profilesToShow.length - 1 || hiddenProfiles.length > 0) && <span>{",\u00A0"}</span>}
        </React.Fragment>
      ))}
      {hiddenProfiles.length > 0 && (
        <SimpleTooltip text={hiddenProfileNames}>
          <span>{`+${hiddenProfiles.length} ${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.More
          )}`}</span>
        </SimpleTooltip>
      )}
    </Grid>
  );
};

export default MultiPersonNames;
